var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"group",attrs:{"to":_vm.route}},[_c('i',{class:[_vm.iconClass, 'bx-sm', 'icon']}),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }